import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AlertsSettings } from "../../../services/reports.service";

@Component({
  selector: "alert-settings",
  templateUrl: "./alert-settings.component.html",
  styleUrls: ["./alert-settings.component.scss"],
})
export class AlertSettingsComponent implements OnInit {
  @Input()
  alertsSettings: AlertsSettings = new AlertsSettings();

  @Output()
  onApplySettings = new EventEmitter<AlertsSettings>();

  constructor() {}

  ngOnInit(): void {
    if (!this.alertsSettings) {
      this.alertsSettings = new AlertsSettings();
    }
  }

  updateGapAlertsSettings(isActive: boolean) {
    console.log("clicking on gaps alerts checkbox");

    if (this.alertsSettings) {
      this.alertsSettings.gapsReportEnabled = isActive;
    } else {
      const newAlertSettings = new AlertsSettings();
      newAlertSettings.gapsReportEnabled = isActive;

      this.alertsSettings = newAlertSettings;
    }

    // this.applySettings();
  }

  updateMissingSubtitleAlertsSettings(isActive: boolean) {
    console.log("clicking on missing subtitles alerts checkbox ", isActive);

    if (this.alertsSettings) {
      this.alertsSettings.missingSubtitleReportEnabled = isActive;
    } else {
      const newAlertSettings = new AlertsSettings();
      newAlertSettings.missingSubtitleReportEnabled = isActive;

      this.alertsSettings = newAlertSettings;
    }

    // this.applySettings();
  }

  updateEmptyContractAlertsSettings(isActive: boolean) {
    console.log("clicking on empty contracts alerts checkbox ", isActive);

    if (this.alertsSettings) {
      this.alertsSettings.emptyContractReportEnabled = isActive;
    } else {
      const newAlertSettings = new AlertsSettings();
      newAlertSettings.emptyContractReportEnabled = isActive;

      this.alertsSettings = newAlertSettings;
    }
  }

  updateMissingAudiosAlertsSettings(isActive: boolean) {
    console.log("clicking on missing audios alerts checkbox ", isActive);

    if (this.alertsSettings) {
      this.alertsSettings.missingAudiosReportEnabled = isActive;
    } else {
      const newAlertSettings = new AlertsSettings();
      newAlertSettings.missingAudiosReportEnabled = isActive;

      this.alertsSettings = newAlertSettings;
    }

    // this.applySettings();
  }

  updateDaysFilter($event: any) {
    const selectedValue = $event;

    this.alertsSettings.alertsTimespanInDays = selectedValue;
    // this.applySettings();
  }

  applySettings() {
    if (!this.alertsSettings) {
      this.alertsSettings = new AlertsSettings();
    }

    this.onApplySettings.emit(this.alertsSettings);
  }
}
